export const knowledgeGraph = [
    {
        "name": "海洋天然产物知识图谱",
        "content": "海纳百川    有容乃大\n今天    拥抱海洋",
        "feature": [
            "3万余 个海洋化合物小分子",
            "10类 实体信息",
            "95万 实体",
            "226万 关系"
        ],
        "img": '../assets/img/ocean_medicine_1.jpg',
        "font_color": 'black'
    },
    {
        "name": "药物靶点知识图谱",
        "content": "一榫一卯    一阴一阳\n药靶之间    尽显大道",
        "feature": [
            "药物、靶点、蛋白质等11类实体",
            "130余万 实体",
            "2,172万 外部关系",
            "573万 内部关系"
        ],
        "img": '../assets/img/drug_target_2.jpg',
        "img-style": ''
    },
    {
        "name": "药物文献知识图谱",
        "content": "岁月静好   明日可期\n每一篇文献都在等待她的最美时光",
        "feature": [
            "3096万 篇生物医药文献",
            "6亿 条关系",
            "14亿 条属性",
            "智能推理、检索、应用"
        ],
        "img": '../assets/img/paper_1.jpg',
        "img-style": ''
    },
    {
        "name": "PPI知识图谱",
        "content": "\n蛋白质间的浪漫情话",
        "feature": [
            "58万 实体",
            "200万 条关系",
            "多种检索深度综合查询"
        ],
        "img": '../assets/img/protein_1.jpg',
        "img-style": '',
        "routerUrl": "/ppi_kg"
    },
    {
        "name": "DDI知识图谱",
        "content": "默默无言  任劳任怨  承载好功能\n结构域：我是人体中的活雷锋",
        "feature": [
            "17929 个实体",
            "13499 条关系",
            "779869 条向蛋白质的映射",
            "支持结构域与蛋白的联合推理"
        ],
        "img": '../assets/img/DDI_1.jpg',
        "img-style": ''
    },
    {
        "name": "中医药知识图谱",
        "content": "金木水火土    酸甜苦辣咸\n风暑湿燥寒    喜怒思忧恐",
        "feature": [
            "295 个实体",
            "866 条关系",
            "中药有效成分挖掘",
        ],
        "img": '../assets/img/chinese_medicine.jpg',
        "img-style": ''
    },
    {
        "name": "COVID-19知识图谱",
        "content": "万众一心    众志成城\n风雨过后必将是彩虹",
        "feature": [
            "1083 个实体",
            "2303 条关系",
            "科学文献自动分类",
            "科研人员社交关系推理"
        ],
        "img": '../assets/img/covid-19.jpg',
        "img-style": ''
    }
];

export const searchItem = [
    {
        "name": "蛋白质查询",
        "content": "这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍",
        "feature": [
            "这里是特点一",
            "这里是特点二",
            "这里是特点三",
            "这里是特点四"
        ],
        "img": '../assets',
        "img-style": ''
    },
    {
        "name": "结构域查询",
        "content": "这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍",
        "feature": [
            "这里是特点一",
            "这里是特点二",
            "这里是特点三",
            "这里是特点四"
        ],
        "img": '../assets',
        "img-style": ''
    },
    {
        "name": "物种查询",
        "content": "这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍",
        "feature": [
            "这里是特点一",
            "这里是特点二",
            "这里是特点三",
            "这里是特点四"
        ],
        "img": '../assets',
        "img-style": ''
    },
    {
        "name": "文献查询",
        "content": "这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍",
        "feature": [
            "这里是特点一",
            "这里是特点二",
            "这里是特点三",
            "这里是特点四"
        ],
        "img": '../assets',
        "img-style": ''
    },
    {
        "name": "蛋白质共现文献查询",
        "content": "这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍",
        "feature": [
            "这里是特点一",
            "这里是特点二",
            "这里是特点三",
            "这里是特点四"
        ],
        "img": '../assets',
        "img-style": ''
    }
];

export const database = [
    {
        "name": "蛋白质/基因同义词表",
        "content": "这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍",
        "feature": [
            "这里是特点一",
            "这里是特点二",
            "这里是特点三",
            "这里是特点四"
        ],
        "img": '../assets',
        "img-style": ''
    },
    {
        "name": "生物物种分类树",
        "content": "这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍",
        "feature": [
            "这里是特点一",
            "这里是特点二",
            "这里是特点三",
            "这里是特点四"
        ],
        "img": '../assets',
        "img-style": ''
    },
    {
        "name": "蛋白质共现文献",
        "content": "这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍",
        "feature": [
            "这里是特点一",
            "这里是特点二",
            "这里是特点三",
            "这里是特点四"
        ],
        "img": '../assets',
        "img-style": ''
    },
    {
        "name": "Taxonomy-Mesh 映射MAP",
        "content": "这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍",
        "feature": [
            "这里是特点一",
            "这里是特点二",
            "这里是特点三",
            "这里是特点四"
        ],
        "img": '../assets',
        "img-style": ''
    },
    {
        "name": "药学文献",
        "content": "这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍",
        "feature": [
            "这里是特点一",
            "这里是特点二",
            "这里是特点三",
            "这里是特点四"
        ],
        "img": '../assets',
        "img-style": ''
    }
];

export const tools = [
    {
        "name": "本体解析工具",
        "content": "这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍",
        "feature": [
            "这里是特点一",
            "这里是特点二",
            "这里是特点三",
            "这里是特点四"
        ],
        "img": '../assets',
        "img-style": ''
    },
    {
        "name": "实体切片工具",
        "content": "这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍",
        "feature": [
            "这里是特点一",
            "这里是特点二",
            "这里是特点三",
            "这里是特点四"
        ],
        "img": '../assets',
        "img-style": ''
    },
    {
        "name": "药学数据综合解析工具",
        "content": "这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍这里放介绍",
        "feature": [
            "这里是特点一",
            "这里是特点二",
            "这里是特点三",
            "这里是特点四"
        ],
        "img": '../assets',
        "img-style": ''
    }
];